import {
	blackColors,
	primaryColor,
	whiteColor,
	blackColor,
	defaultBodyFont,
	hexToRgb,
	light_grey_2,
	grayColorShade_4,
} from 'assets/jss/material-dashboard-pro-react';
import { darken } from '@material-ui/core/styles';
import typographyStyle from './typographyStyle';

const customTableStyle = (theme, ...props) => ({
	'@keyframes newRow': {
		from: {
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.06)`,
			fallbacks: {
				background: `
			linear-gradient(rgba(${hexToRgb(theme.palette.primary.main)}, 0.06), rgba(${hexToRgb(
					theme.palette.primary.main
				)}, 0.06)), linear-gradient(${whiteColor}, ${whiteColor})`,
			},
		},
		to: {
			background: 'inherit',
		},
	},
	newRow: {
		animation: '$newRow 3s 1',
	},
	results: {
		paddingTop: 0,
		marginRight: theme.direction === 'rtl' ? 5 : 10,
		marginBottom: 0,
		'& > *': {
			marginRight: 5,
		},
		[theme.browser.IE]: {
			marginTop: 1,
		},
	},
	show: {
		paddingTop: 0,
		marginRight: 5,
		marginBottom: 0,
		[theme.browser.IE]: {
			marginTop: 1,
		},
	},
	table: {
		...defaultBodyFont,
		fontSize: 12,
		lineHeight: '16px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		'& .rt-tr': {
			position: 'relative',
		},
		'&& .rt-tr .rt-th': {
			...typographyStyle(theme, ...props).bodyS,
		},
		'& .rt-td': {
			margin: 0,
			paddingTop: 13,
			paddingBottom: 11,
			height: 56,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			[theme.breakpoints.down('md')]: {
				minWidth: '150px !important',
			},
			'&:first-of-type': {
				paddingLeft: 16,
				display: 'flex',
				alignItems: 'center',
				[theme.breakpoints.down('sm')]: {
					paddingLeft: 10,
				},
				[theme.breakpoints.down('md')]: {
					minWidth: 'unset !important',
				},
			},
		},

		'& .rt-th': {
			height: 56,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			'&:first-of-type': {
				margin: 'auto!important',
				paddingLeft: 16,
				[theme.breakpoints.down('sm')]: {
					paddingLeft: 10,
				},
				textAlign: 'left',
				'& > div': {
					display: 'flex',
					alignItems: 'center',
				},
			},
		},
		'& .rt-tr-group:has(.Mui-checked)': {
			backgroundColor: grayColorShade_4,
		},
		'& .rt-thead': {
			backgroundColor: grayColorShade_4,
		},
		'& .rt-table': {
			backgroundColor: whiteColor,
		},
		'& .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after': {
			opacity: '1',
			color: `${light_grey_2} !important`,
			// content: '"\\2191" !important',
			// transform: 'rotate(180deg) !important'
		},
		'& .rt-thead .rt-th.-cursor-pointer > div:first-of-type:empty:after': {
			opacity: '0',
		},
	},
	withStroke: {
		borderRadius: '0 0 8px 8px',
		border: `solid 1px rgba(0, 0, 0, 0.12)`,
	},
	borderRadius: {
		'& .rt-table': {
			borderBottomLeftRadius: '8px',
			borderBottomRightRadius: '8px',
		},
	},
	alignColumnsCenter: ({ alignColumnsCenter }) => {
		if (alignColumnsCenter) {
			let obj1 = {};
			let obj2 = {};

			alignColumnsCenter.forEach((el) => {
				obj1[`&:nth-of-type(${el})`] = {
					justifyContent: 'center',
				};
				obj2[`&:nth-of-type(${el})`] = {
					justifyContent: 'center',
					paddingRight: '20px',
				};
			});
			return {
				'& .rt-th': { ...obj1 },
			};
		}
	},
	alignColumnsRight: ({ alignColumnsRight }) => {
		if (alignColumnsRight) {
			let obj1 = {};
			let obj2 = {};

			alignColumnsRight.forEach((el) => {
				obj1[`&:nth-of-type(${el})`] = {
					justifyContent: 'flex-end',
				};
				obj2[`&:nth-of-type(${el})`] = {
					justifyContent: 'flex-end',
					paddingRight: '20px',
				};
			});
			return {
				'& .rt-th': { ...obj1 },
				'& .rt-td': { ...obj2 },
			};
		}
	},
	pageSizeContainer: {
		display: 'flex',
		flex: '1',
		minWidth: 100,
		width: '100%',
		alignItems: 'center',
	},
	customSelectWrapper: {
		width: 40,
		margin: '0!important',
		'& svg': {
			right: 4,
		},
	},
	paginationContainer: {
		display: 'flex',
		paddingTop: 16,
		paddingBottom: 5,
	},
	pageCounterContainer: {
		color: blackColors[3],
		fontSize: 12,
		lineHeight: '16px',
		flex: '1',
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	pageCounterPage: {
		padding: theme.direction === 'rtl' ? '9px 4px 7px 8px' : '8px 4px 8px 8px',
		width: 50,
		height: 30,
		fontSize: 12,
		lineHeight: '16px',
		marginRight: 4,
		'& > .MuiSelect-select': {
			paddingRight: theme.direction === 'rtl' ? 0 : 'inherit',
		},
		zIndex: 0,
	},
	textFieldRoom: {
		padding: theme.direction === 'rtl' ? '9px 4px 7px 4px' : '8px 4px',
		width: 40,
		height: 30,
		fontSize: 12,
		lineHeight: '16px',
		marginRight: 4,
	},
	pageCounterPageInput: {
		padding: 0,
		textAlign: 'left',
		color: blackColor[2],
		zIndex: 2,
		[theme.browser.IE]: {
			paddingBottom: 5,
		},
	},
	pageCounterNumber: {
		marginLeft: 2,
		display: 'inline-block',
	},
	pageCounterNotchedOutline: {
		borderColor: blackColors[4],
		backgroundColor: blackColors[6],
		'.Mui-focused &': {
			backgroundColor: whiteColor,
		},
	},
	chevronEnabled: {
		color: primaryColor[0],
		cursor: 'pointer',
	},
	chevronDisabled: {
		color: blackColors[4],
	},
	chevron: {
		transform: theme.direction === 'rtl' ? 'scale(-1)' : 'none',
	},
	customSelect: {
		margin: '0 !important',
	},
	paginationContainerWrapper: {
		backgroundColor: whiteColor,
		paddingLeft: '16px',
		paddingRight: '16px',
		borderTopLeftRadius: '8px',
		borderTopRightRadius: '8px',
		position: 'relative',
	},
	paginationContainerWrapperWithHeader: {
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
	},
	selectPanel: {
		position: 'absolute',
		left: 0,
		top: 0,
		height: '100%',
		width: '80%',
		zIndex: 2,
		backgroundColor: darken(primaryColor[0], 0.38),
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '0 14px',
		borderTopRightRadius: 8,
		borderTopLeftRadius: 8,
		[theme.breakpoints.down('sm')]: {
			width: 'calc(100% - 125px)',
		},
	},
	selectPanelArrow: {
		position: 'absolute',
		borderTop: `9px solid ${darken(primaryColor[0], 0.38)}`,
		borderLeft: '9px solid transparent',
		borderRight: '9px solid transparent',
		borderBottom: 'none',
		bottom: '-9px',
		left: '15px',
	},
	selectPanelIconWrapper: {
		display: 'flex',
		alignItems: 'center',
		'& svg': {
			color: whiteColor,
		},
		'& span span, & > div': {
			transition: 'all .1s ease-in-out',
			'&:hover': {
				backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.2)`,
			},
		},
	},
	deleteIcon: {
		cursor: 'pointer',
		marginRight: '10px',
		padding: '6px 8px 4px',
	},
	deleteIconDisabled: {
		color: 'rgba(255,255,255,0.5) !important',
	},
	confirmationDialogBody: {},
	checkbox: {
		padding: 0,
		'& svg': {
			padding: 7,
		},
	},
	checkboxChecked: {
		'& svg': {
			width: 16,
			height: 16,
			padding: 0,
		},
	},
	checkboxAll: {},
});

export default customTableStyle;
